/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { KubernetesCluster } from '../models/kubernetes-cluster';
import { KubernetesClusterRequest } from '../models/kubernetes-cluster-request';

/**
 * Ui K 8s Cluster Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiK8sClusterControllerService extends __BaseService {
  static readonly createK8sClusterUsingPOSTPath =
    '/cc-ui/v1/kubernetes/clusters';
  static readonly createDraftClusterUsingPOST1Path =
    '/cc-ui/v1/kubernetes/clusters/configure/{clusterId}';
  static readonly getK8sClusterUsingGETPath =
    '/cc-ui/v1/kubernetes/clusters/{clusterId}';
  static readonly updateK8sClusterUsingPUTPath =
    '/cc-ui/v1/kubernetes/clusters/{clusterId}';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * createK8sCluster
   * @param request request
   * @return OK
   */
  createK8sClusterUsingPOSTResponse(
    request: KubernetesClusterRequest,
  ): __Observable<__StrictHttpResponse<KubernetesCluster>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/kubernetes/clusters`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KubernetesCluster>;
      }),
    );
  }
  /**
   * createK8sCluster
   * @param request request
   * @return OK
   */
  createK8sClusterUsingPOST(
    request: KubernetesClusterRequest,
  ): __Observable<KubernetesCluster> {
    return this.createK8sClusterUsingPOSTResponse(request).pipe(
      __map((_r) => _r.body as KubernetesCluster),
    );
  }

  /**
   * createDraftCluster
   * @param params The `UiK8sClusterControllerService.CreateDraftClusterUsingPOST1Params` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  createDraftClusterUsingPOST1Response(
    params: UiK8sClusterControllerService.CreateDraftClusterUsingPOST1Params,
  ): __Observable<__StrictHttpResponse<KubernetesCluster>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/kubernetes/clusters/configure/${encodeURIComponent(
          String(params.clusterId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KubernetesCluster>;
      }),
    );
  }
  /**
   * createDraftCluster
   * @param params The `UiK8sClusterControllerService.CreateDraftClusterUsingPOST1Params` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  createDraftClusterUsingPOST1(
    params: UiK8sClusterControllerService.CreateDraftClusterUsingPOST1Params,
  ): __Observable<KubernetesCluster> {
    return this.createDraftClusterUsingPOST1Response(params).pipe(
      __map((_r) => _r.body as KubernetesCluster),
    );
  }

  /**
   * getK8sCluster
   * @param clusterId clusterId
   * @return OK
   */
  getK8sClusterUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<KubernetesCluster>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/kubernetes/clusters/${encodeURIComponent(
          String(clusterId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KubernetesCluster>;
      }),
    );
  }
  /**
   * getK8sCluster
   * @param clusterId clusterId
   * @return OK
   */
  getK8sClusterUsingGET(clusterId: string): __Observable<KubernetesCluster> {
    return this.getK8sClusterUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as KubernetesCluster),
    );
  }

  /**
   * updateK8sCluster
   * @param params The `UiK8sClusterControllerService.UpdateK8sClusterUsingPUTParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  updateK8sClusterUsingPUTResponse(
    params: UiK8sClusterControllerService.UpdateK8sClusterUsingPUTParams,
  ): __Observable<__StrictHttpResponse<KubernetesCluster>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/kubernetes/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KubernetesCluster>;
      }),
    );
  }
  /**
   * updateK8sCluster
   * @param params The `UiK8sClusterControllerService.UpdateK8sClusterUsingPUTParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  updateK8sClusterUsingPUT(
    params: UiK8sClusterControllerService.UpdateK8sClusterUsingPUTParams,
  ): __Observable<KubernetesCluster> {
    return this.updateK8sClusterUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as KubernetesCluster),
    );
  }
}

module UiK8sClusterControllerService {
  /**
   * Parameters for createDraftClusterUsingPOST1
   */
  export interface CreateDraftClusterUsingPOST1Params {
    /**
     * request
     */
    request: KubernetesClusterRequest;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for updateK8sClusterUsingPUT
   */
  export interface UpdateK8sClusterUsingPUTParams {
    /**
     * request
     */
    request: KubernetesClusterRequest;

    /**
     * clusterId
     */
    clusterId: string;
  }
}

export { UiK8sClusterControllerService };
